import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddUserIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M7.99992 1.33337C6.25325 1.33337 4.83325 2.75337 4.83325 4.50004C4.83325 6.21337 6.17325 7.60004 7.91992 7.66004C7.97325 7.65337 8.02659 7.65337 8.06659 7.66004C8.07992 7.66004 8.08659 7.66004 8.09992 7.66004C8.10659 7.66004 8.10659 7.66004 8.11325 7.66004C9.81992 7.60004 11.1599 6.21337 11.1666 4.50004C11.1666 2.75337 9.74659 1.33337 7.99992 1.33337Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M11.3866 9.4333C9.52664 8.1933 6.49331 8.1933 4.61997 9.4333C3.77331 9.99996 3.30664 10.7666 3.30664 11.5866C3.30664 12.4066 3.77331 13.1666 4.61331 13.7266C5.54664 14.3533 6.77331 14.6666 7.99997 14.6666C9.22664 14.6666 10.4533 14.3533 11.3866 13.7266C12.2266 13.16 12.6933 12.4 12.6933 11.5733C12.6866 10.7533 12.2266 9.9933 11.3866 9.4333Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M9.33341 11.0866H8.50008V10.2533C8.50008 9.97996 8.27341 9.7533 8.00008 9.7533C7.72675 9.7533 7.50008 9.97996 7.50008 10.2533V11.0866H6.66675C6.39341 11.0866 6.16675 11.3133 6.16675 11.5866C6.16675 11.86 6.39341 12.0866 6.66675 12.0866H7.50008V12.92C7.50008 13.1933 7.72675 13.42 8.00008 13.42C8.27341 13.42 8.50008 13.1933 8.50008 12.92V12.0866H9.33341C9.60675 12.0866 9.83341 11.86 9.83341 11.5866C9.83341 11.3133 9.60675 11.0866 9.33341 11.0866Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_4)
  ]))
}
}

})